import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import AppShell from "./components/AppShell";
import { AuthProvider } from "./auth/AuthProvider";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";

/* global document, Office, module, require, HTMLElement */

// Identify the container div in taskpane.html
const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

function Tree({ AppComponent }: { AppComponent: React.ComponentType }) {
  return (
    <FluentProvider theme={webLightTheme}>
      <AuthProvider>
        <AppShell>
          <AppComponent />
        </AppShell>
      </AuthProvider>
    </FluentProvider>
  );
}

/**
 * Render application after Office initializes
 */
Office.onReady(() => {
  root?.render(<Tree AppComponent={App} />);
});

/**
 * Enable hot module replacement (HMR)
 * so that changes to App.tsx can be loaded without restarting the dev server.
 */
if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(<Tree AppComponent={NextApp} />);
  });
}
